module.exports = {
      id: "rsvp-success-icon-usage",
      viewBox: "0 0 90 90",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#rsvp-success-icon",
      toString: function () {
        return this.url;
      }
    }